import {
  WIX_CONFIG_FILENAME,
  getWixConfigFilePath,
} from '@wix/cli-core-definitions';
import { readJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { wixAstroConfigSchema } from '@wix/cli-astro-definitions';

export async function readWixConfig(projectFolder: string) {
  const configFile = await readJson(getWixConfigFilePath(projectFolder));
  const config = wixAstroConfigSchema.safeParse(configFile);

  if (config.success) {
    return config.data;
  }

  throw new CliError({
    code: CliErrorCode.InvalidConfigSchemaError({
      configPath: WIX_CONFIG_FILENAME,
      zodError: config.error,
    }),
    cause: config.error,
  });
}
